import * as React from "react";
import { observer } from "mobx-react";
import { TravelersField } from "components/shared/TravelersField";
import { travelersState } from "src/stores/wizard/state/global/travelers";
import { TravelersFieldConfig } from "src/stores/wizard/config";
import { travelersMetadata } from "../TravelersField/utils";
import { UitkLayoutConditionalGridSpan, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";
import { TRAVELERS_HIDDEN_INPUT_TYPE } from "src/components/shared/TravelersField";
import { LOBState } from "src/stores/wizard/state";
import { NoRehydratationValues, TravelersTriggerTypes } from "../TravelersField/typings";

export interface TravelersProps {
  colSpan?: UitkLayoutConditionalGridSpan;
  lobState: LOBState;
  config?: TravelersFieldConfig;
  hidden?: boolean;
  tripLobType?: string;
  noRehydratationValues?: NoRehydratationValues;
  triggerType?: TravelersTriggerTypes;
  isApiCallEnabled?: boolean;
  handleMenuTriggerState?: (menuState: boolean) => void;
}

export const Travelers = observer((props: TravelersProps) => {
  if (props.hidden) {
    return null;
  }
  const { formatText } = useLocalization();

  const config: TravelersFieldConfig = props.config ? props.config : props.lobState.config.travelers;
  const travelers = !!props.lobState.travelers ? props.lobState.travelers : travelersState;
  const hotelTravelersInvalidKey = props.lobState.hotelTravelersInvalidKey
    ? formatText(props.lobState.hotelTravelersInvalidKey, config.maxBookableTravelers)
    : "";
  const nonHotelTravelersInvalidKey = props.lobState.nonHotelTravelersInvalidKey
    ? formatText(props.lobState.nonHotelTravelersInvalidKey, config.maxBookableTravelers)
    : "";
  const hotelPackageTravelersMetadata = props.lobState.hotelPackageTravelersMetadata
    ? props.lobState.hotelPackageTravelersMetadata
    : travelersMetadata(travelers.hotelPackage);

  const hotelTravelersMetadata = props.lobState.hotelTravelersMetadata
    ? props.lobState.hotelTravelersMetadata
    : travelersMetadata(travelers.hotel);

  const nonHotelTravelersMetadata = props.lobState.nonHotelTravelersMetadata
    ? props.lobState.nonHotelTravelersMetadata
    : travelersMetadata(travelers.nonHotel);

  const cruiseTravelersMetadata = props.lobState.cruiseTravelersMetadata
    ? props.lobState.cruiseTravelersMetadata
    : travelersMetadata(travelers.cruise);

  return (
    <UitkLayoutGridItem colSpan={props.colSpan}>
      <div className="TravelersField">
        <TravelersField
          travelers={
            config.withRooms && props.tripLobType
              ? travelers.hotelPackage
              : config.withRooms
              ? travelers.hotel
              : config.hiddenInputType === TRAVELERS_HIDDEN_INPUT_TYPE.CRUISE_SEARCH
              ? travelers.cruise
              : travelers.nonHotel
          }
          config={config}
          onSave={
            config.withRooms
              ? props.lobState.updateHotelTravelersSelection!
              : props.lobState.updateNonHotelTravelersSelection!
          }
          invalid={config.withRooms ? hotelTravelersInvalidKey : nonHotelTravelersInvalidKey}
          metadata={
            config.withRooms && props.tripLobType
              ? hotelPackageTravelersMetadata
              : config.withRooms
              ? hotelTravelersMetadata
              : config.hiddenInputType === TRAVELERS_HIDDEN_INPUT_TYPE.CRUISE_SEARCH
              ? cruiseTravelersMetadata
              : nonHotelTravelersMetadata
          }
          tripLobType={props.tripLobType}
          setChange={props.lobState.setTravelersValue}
          isChanged={props.lobState.travelersValueChanged}
          noRehydratationValues={props.noRehydratationValues}
          lobState={props.lobState}
          triggerType={props.triggerType}
          isApiCallEnabled={props.isApiCallEnabled}
          handleMenuTriggerState={props.handleMenuTriggerState}
        />
      </div>
    </UitkLayoutGridItem>
  );
});
